import React from "react";
import SelectField from "./select_field";

export default class EventListForm extends React.Component {
	constructor(props) {
		super(props);
		this.eventListState = props.eventListState;
	}

	render() {
		return (
			<form className="event-list-form__form" action="" onSubmit={this.eventListState.form.onClickViewResults}>
				<div>
					<SelectField
						id="dateRange"
						fieldName="dateRange"
						options={this.eventListState.form.choices.dateRanges}
						value={this.eventListState.form.data.dateRange}
						onChange={(value) =>
							this.eventListState.form.onSelectFieldChange(
								this.eventListState.form,
								"dateRange",
								value
							)
						}
					/>
					<span className="custom-select__indicator"></span>
				</div>

				<div>
					<SelectField
						id="eventCategory"
						fieldName="eventCategory"
						options={this.eventListState.form.choices.eventCategories}
						value={this.eventListState.form.data.eventCategory}
						onChange={(value) =>
							this.eventListState.form.onSelectFieldChange(
								this.eventListState.form,
								"eventCategory",
								value
							)
						}
					/>
					<span className="custom-select__indicator"></span>
				</div>
				<button className="event-list-form__btn sr-skip-link" type="submit">
					View results
				</button>
			</form>
		);
	}
}
